<template>
  <div>
    <md-card>
      <md-card-header>
        <span class="md-title">{{ L(titleKey) }}</span>
      </md-card-header>

      <md-card-content>
        <GChart
          type="PieChart"
          :events="chartEvents"
          :data="chartData"
          :options="chartOptions"
          ref="chart"
        />

        <md-table
          v-if="sortedData.length > 0"
          v-model="sortedData"
          class="min-table"
          md-thin
          md-stripe
          md-fixed-header
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell
              :md-label="L(nameKey)"
              @click.native.stop="tableRowClick(item)"
              >{{ item.name }}</md-table-cell
            >
            <md-table-cell :md-label="L('cost')" md-numeric>{{
              item.cost | formatCurrency(currency)
            }}</md-table-cell>
          </md-table-row>
        </md-table>

        <md-table class="total-table" md-thin>
          <md-table-row slot="md-table-row">
            <md-table-cell>{{ L('totalCost') }}</md-table-cell>
            <md-table-cell style="text-align: right">{{
              totalCost | formatCurrency(currency)
            }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  components: { GChart },

  props: {
    titleKey: String,
    nameKey: String,
    data: Array,
    currency: String,
  },

  data() {
    return {
      chartEvents: {
        select: () => {
          const selectedInfo = this.$refs.chart.chartObject.getSelection()[0]
          if (selectedInfo === undefined) return
          this.$refs.chart.chartObject.setSelection()

          this.$emit(
            'click',
            this.titleKey,
            this.sortedData[selectedInfo.row].name
          )
        },
      },
    }
  },

  computed: {
    sortedData() {
      return (this.data || []).sort((a, b) => b.cost - a.cost)
    },

    chartData() {
      return [
        [this.L('name'), this.L('cost')],
        ...this.sortedData
          .filter((elem) => elem.cost > 0)
          .map((elem) => [elem.name, elem.cost]),
      ]
    },

    chartOptions() {
      return {
        chartArea: {
          width: '100%',
          height: '100%',
          top: 7,
          bottom: 7,
        },
        sliceVisibilityThreshold: 0.01,
        backgroundColor: 'none',
      }
    },

    totalCost() {
      return this.sortedData.reduce((sum, elem) => sum + elem.cost, 0)
    },
  },

  methods: {
    tableRowClick(item) {
      this.$emit('click', this.titleKey, item.name)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .min-table {
  height: 172px;
}

::v-deep .total-table {
  font-weight: bold;
}
</style>
